import type { Props } from '../types';
import { NarrativeHeader } from '../../PublicNarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';

export const DesktopLayout = ({
  errors,
  values,
  onChange,
  onSetFairValue,
  isLoading,
  onSubmit,
  submitLabel,
  owner,
  initialContentHtml,
  company,
  onReset,
  pastAnnualRevenueEarnings,
  narrativeId,
  calculationBreakDownOutput,
  onContentChange,
  onHeaderChange,
}: Props) => {
  return (
    <>
      <div className="grid grid-rows-[min-content_min-content_auto] content-start gap-x2">
        <NarrativeHeader
          errors={errors}
          values={values}
          onChange={onHeaderChange}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={submitLabel}
          owner={owner}
          company={company}
        />
        <PublicNarrativeRichTextEditor
          onUpdate={onContentChange}
          defaultContent={initialContentHtml}
        />
      </div>

      <NarrativeSidebar
        company={company}
        onChange={onChange}
        onSetFairValue={onSetFairValue}
        values={values}
        onReset={onReset}
        readOnly={false}
        owner={{
          displayName: owner?.displayName || '',
          publicId: owner?.publicId || '',
        }}
        narrativeType={'USER'}
        pastAnnualRevenueEarnings={pastAnnualRevenueEarnings}
        narrativeId={narrativeId}
        calculationBreakDownOutput={calculationBreakDownOutput}
      />
    </>
  );
};
